import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController, PopoverController, ToastController, LoadingController } from '@ionic/angular';
import cloneDeep from 'lodash/cloneDeep';
import { DatePipe } from '@angular/common';
import { OrderSlotService } from 'src/app/services/order-slot.service';

import { async } from '@angular/core/testing';
import { DatePicker } from '@ionic-native/date-picker/ngx';

@Component({
  selector: 'reservationstatus-popover',
  templateUrl: 'reservationPreSelectMenuPopup.html',
  styleUrls: ['reservationPreSelectMenuPopup.scss'],

})

export class reservationPreSelectMenuPopup implements OnInit {

 
  constructor(private datePicker: DatePicker, public toastController: ToastController, public loadingController: LoadingController, public datePipe: DatePipe, public navParams: NavParams, private popoverController: PopoverController, public orderSlot: OrderSlotService) {
  }

  ngOnInit() {

    

  }

  async yesClick() {
    
    this.popoverController.dismiss("yes");

  }
  async noClick() {
    
    this.popoverController.dismiss("no");
  }
 
}
